<template>
  <div class="control_bar top">
    <div class="search">
      <input
        type="text"
        class="search_field"
        placeholder="端末名、電話番号から検索"
        v-model="inputValue"
      />
      <input
        type="button"
        :value="search"
        class="search_button"
        @click="deviceFindAction"
      />
    </div>
    <controller
      :dispItems="dispItems"
      :allItems="devices"
      :router="router"
      @remove="remove"
      @import="importModal"
      @exportFile="exportFile"
    >
    </controller>
    <div class="false_modal_window" v-if="showFinishModal">
      <finishModalWindow :question="finishWord" @close="close">
      </finishModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
    <div class="import_modal_window" v-if="showImportModal">
      <importModalWindow @close="closeModal" @import="importFile">
      </importModalWindow>
    </div>
  </div>
</template>

<script>
import controller from '../controller.vue'
import finishModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'
import importModalWindow from '../modalWindow/importModalWindow.vue'
import * as XLSX from 'xlsx-js-style'

export default {
  props: ['dispItems'],
  data() {
    return {
      inputValue: '',
      search: '検索',
      showFinishModal: false,
      finishWord: '',
      router: '/devices/add',
      showloadingModal: false,
      showImportModal: false,
      excelData: null,
      confirmed: ''
    }
  },
  computed: {
    devices() {
      return this.$store.state.devices.devices
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    indexOfCallAppList() {
      return this.$store.state.masters.masterData.callAppList.length
    },
    selectedDeviceList() {
      return this.$store.state.devices.selectedDeviceList
    }
  },
  components: {
    controller,
    finishModalWindow,
    loadingModalWindow,
    importModalWindow
  },
  methods: {
    close(e) {
      this.showFinishModal = false
    },
    closeModal(e) {
      this.showImportModal = false
      this.showFinishModal = false
    },
    async remove(e) {
      let selectedDeviceIdList = this.selectedDeviceList.map((device) => {
        let deviceId = device.deviceId
        return {deviceId}
      })
      this.showloadingModal = true
      try {
        await this.$store.dispatch(
          'devices/deleteDevices',
          selectedDeviceIdList
        )
        this.$store.dispatch('devices/clearSelectedDeviceList')
        this.finishWord = '対象の端末を削除しました。'
        this.showFinishModal = true
        // 削除ボタン押下時は詳細画面を初期化する
        if (location.pathname !== '/devices') {
          this.$router.push('/devices')
        }
        this.$emit('list-reload')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_140003
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message
          if (errorMessage === 'MSGCRC0020') {
            this.finishWord =
              this.errorMsg.MSGCRC0020.name +
              this.errorMsg.MSGCRC0020.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0264') {
            this.finishWord =
              this.errorMsg.MSGCRC0264.name +
              this.errorMsg.MSGCRC0264.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          reason = errorMessage + ' '
          reason += error.response.status
        } else if (error.response && error.response.data) {
          reason = 'MSGCRC0020'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0020.name +
            this.errorMsg.MSGCRC0020.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFinishModal = true
      }
      this.showloadingModal = false
    },
    deviceFindAction(event) {
      this.$emit('input-event', 0, this.inputValue)
      this.confirmed = this.inputValue
    },
    importModal(data) {
      this.excelData = data
      this.showImportModal = true
    },
    async importFile() {
      this.showImportModal = false
      this.showloadingModal = true
      var createList = []
      setTimeout(async () => {
        try {
          const excelDataList = this.loadExcelData(this.excelData)
          createList = createList.concat(excelDataList)
        } catch (error) {
          this.showloadingModal = false
          return
        }
        if (location.pathname !== '/devices') {
          this.$router.push('../devices')
        }
        try {
          await this.$store.dispatch('devices/importDevices', createList)
          this.$emit('list-reload')
          this.finishWord = 'インポートしました。'
          this.showFinishModal = true
        } catch (error) {
          let eventNumber = this.$store.state.error.errorCode.errorCode_140009
          let eventType = 3
          let reason = '端末情報のインポートに失敗しました。'
          if (error.response && error.response.data) {
            if (error.response.data.header) {
              let errorMessage = error.response.data.header.message.split(',')
              if (errorMessage[0] === 'MSGCRC0014') {
                this.finishWord =
                  this.errorMsg.MSGCRC0014.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0014.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0015') {
                this.finishWord =
                  this.errorMsg.MSGCRC0015.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0015.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0092') {
                this.finishWord =
                  this.errorMsg.MSGCRC0092.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0092.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0097') {
                this.finishWord =
                  this.errorMsg.MSGCRC0097.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0097.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0098') {
                this.finishWord =
                  this.errorMsg.MSGCRC0098.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0098.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0124') {
                this.finishWord =
                  this.errorMsg.MSGCRC0124.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0124.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0130') {
                this.finishWord =
                  this.errorMsg.MSGCRC0130.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0130.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0146') {
                this.finishWord =
                  this.errorMsg.MSGCRC0146.name +
                  this.errorMsg.MSGCRC0146.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0162') {
                this.finishWord =
                  this.errorMsg.MSGCRC0162.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0162.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0163') {
                this.finishWord =
                  this.errorMsg.MSGCRC0163.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0163.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0164') {
                this.finishWord =
                  this.errorMsg.MSGCRC0164.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0164.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0165') {
                this.finishWord =
                  this.errorMsg.MSGCRC0165.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0165.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0166') {
                this.finishWord =
                  this.errorMsg.MSGCRC0166.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0166.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0167') {
                this.finishWord =
                  this.errorMsg.MSGCRC0167.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0167.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0168') {
                this.finishWord =
                  this.errorMsg.MSGCRC0168.name +
                  errorMessage[1] +
                  '行目：' +
                  this.errorMsg.MSGCRC0168.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0185') {
                this.finishWord =
                  this.errorMsg.MSGCRC0185.name +
                  (Number(errorMessage[1]) + 1) +
                  this.errorMsg.MSGCRC0185.beforeValue +
                  errorMessage[1] +
                  this.errorMsg.MSGCRC0185.afterValue +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage[0] === 'MSGCRC0264') {
                this.finishWord =
                  this.errorMsg.MSGCRC0264.name +
                  this.errorMsg.MSGCRC0264.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else {
                this.finishWord =
                  this.errorMsg.MSGCRC0021.name +
                  this.errorMsg.MSGCRC0021.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              }
              reason = errorMessage[0] + ' '
              reason += error.response.status
            } else {
              var obj = error.response.data
              var stringName = Object.keys(obj)[0]
              var errorMessage =
                Number(Object.keys(obj)[0].substring(16, 17)) + 2
              if (stringName.endsWith('callAppDivision')) {
                this.finishWord =
                  this.errorMsg.MSGCRC0167.name +
                  errorMessage +
                  '行目：' +
                  this.errorMsg.MSGCRC0167.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
                reason = 'MSGCRC0167'
              } else if (error.response.status === 502) {
                reason = 'MSGCRC0021'
                eventType = 9
                this.finishWord =
                  this.errorMsg.MSGCRC0021.name +
                  this.errorMsg.MSGCRC0021.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else {
                this.finishWord =
                  this.errorMsg.MSGCRC0195.name +
                  this.errorMsg.MSGCRC0195.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
                reason = 'MSGCRC0195'
              }
            }
          } else {
            reason = 'MSGCRC0005'
            eventType = 9
            this.finishWord =
              this.errorMsg.MSGCRC0005.name +
              this.errorMsg.MSGCRC0005.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.showFinishModal = true
        }
        this.showloadingModal = false
      }, 100)
    },
    loadExcelData(excelData) {
      const createList = []
      let workbook
      let excelRows
      try {
        workbook = XLSX.read(excelData, {type: 'array'})
        const sheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[sheetName]
        if (!worksheet) throw new Error('no worksheet')
        excelRows = XLSX.utils.sheet_to_json(worksheet, {
          defval: '',
          raw: false
        })
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_510003
        let eventType = 9
        let reason = 'MSGCRC0314'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (e) {}
        this.finishWord =
          this.errorMsg.MSGCRC0314.name +
          this.errorMsg.MSGCRC0314.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFinishModal = true
        this.showloadingModal = false
        throw new Error()
      }
      if (excelRows.length === 0) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_510002
        let eventType = 9
        let reason = 'MSGCRC0010'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.finishWord =
          this.errorMsg.MSGCRC0010.name +
          this.errorMsg.MSGCRC0010.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFinishModal = true
        this.showloadingModal = false
        throw new Error()
      }
      for (let i = 0; i < excelRows.length; i++) {
        const row = excelRows[i]
        if (!row || Object.keys(row).length === 0) continue
        if (
          !this.$store.state.error.excelColumn.device.every((key) => key in row)
        ) {
          let eventNumber = this.$store.state.error.errorCode.errorCode_140007
          let eventType = 9
          let reason = 'MSGCRC0008'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.finishWord =
            this.errorMsg.MSGCRC0008.name +
            this.errorMsg.MSGCRC0008.beforeValue +
            // キーの情報がない=ヘッダ情報がないとみなし、1に固定
            1 +
            this.errorMsg.MSGCRC0008.afterValue +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFinishModal = true
          this.showloadingModal = false
          throw new Error()
        }
        let obj = {}
        obj['deviceId'] = row.端末ID
        obj['deviceName'] = row.端末名
        obj['phoneNumber'] = row.電話番号
        var upperedValue = row.個人端末フラグ.toUpperCase()
        if (upperedValue === '') {
          let eventNumber = this.$store.state.error.errorCode.errorCode_140009
          let eventType = 9
          let reason = 'MSGCRC0164'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.finishWord =
            this.errorMsg.MSGCRC0164.name +
            (i + 2) +
            '行目：' +
            this.errorMsg.MSGCRC0164.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFinishModal = true
          this.showloadingModal = false
          throw new Error()
        }
        if (upperedValue !== 'TRUE' && upperedValue !== 'FALSE') {
          let eventNumber = this.$store.state.error.errorCode.errorCode_140009
          let eventType = 9
          let reason = 'MSGCRC0165'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.finishWord =
            this.errorMsg.MSGCRC0165.name +
            (i + 2) +
            '行目：' +
            this.errorMsg.MSGCRC0165.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFinishModal = true
          this.showloadingModal = false
          throw new Error()
        }
        const flag = upperedValue === 'TRUE'
        obj['personalDeviceFlag'] = flag
        if (row.使用アプリ区分 === '') {
          let eventNumber = this.$store.state.error.errorCode.errorCode_140009
          let eventType = 9
          let reason = 'MSGCRC0166'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.finishWord =
            this.errorMsg.MSGCRC0166.name +
            (i + 2) +
            '行目：' +
            this.errorMsg.MSGCRC0166.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFinishModal = true
          this.showloadingModal = false
          throw new Error()
        }
        obj['callAppDivision'] = row.使用アプリ区分
        obj['fileRowCount'] = String(i + 2)
        createList.push(obj)
      }
      return createList
    },
    async exportFile() {
      var selectedDeviceIdList = this.selectedDeviceList.map((device) => {
        return {deviceId: device.deviceId}
      })
      this.showloadingModal = true
      try {
        const params = {selectedDeviceIdList: selectedDeviceIdList}
        if (selectedDeviceIdList.length === 0) {
          params.searchWord = this.confirmed ? this.confirmed : ''
        }
        await this.$store.dispatch('devices/setExportData', params)

        const exportList = this.$store.state.devices.exportData
        let result = [this.$store.state.error.excelColumn.device]
        for (let i = 0; i < exportList.length; i++) {
          for (let k of Object.keys(exportList[i])) {
            if (!exportList[i][k] && k !== 'personalDeviceFlag') {
              exportList[i][k] = ''
            }
          }
          result.push([
            exportList[i].deviceId,
            exportList[i].deviceName,
            exportList[i].phoneNumber2,
            '' + exportList[i].personalDeviceFlag,
            '' + exportList[i].callAppDivision
          ])
        }
        if (result === '') {
          let eventNumber = this.$store.state.error.errorCode.errorCode_140008
          let eventType = 9
          let reason = 'MSGCRC0006'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.finishWord =
            this.errorMsg.MSGCRC0006.name +
            this.errorMsg.MSGCRC0006.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFinishModal = true
          this.showloadingModal = false
          return
        }
        const workbook = XLSX.utils.book_new()
        const worksheet = XLSX.utils.aoa_to_sheet(result)

        const ref = worksheet['!ref']
        if (!ref) return
        const range = XLSX.utils.decode_range(ref)

        for (let row = range.s.r; row <= range.e.r; row++) {
          for (let col = range.s.c; col <= range.e.c; col++) {
            const cellAddress = XLSX.utils.encode_cell({r: row, c: col})
            const cell = worksheet[cellAddress]
            if (!cell) continue
            // 文字列設定
            cell.t = 's'
            cell.z = '@'
          }
        }
        XLSX.utils.book_append_sheet(workbook, worksheet, '端末')
        const data = XLSX.write(workbook, {
          type: 'buffer',
          bookSST: true,
          bookType: 'xlsx',
          compression: true
        })
        let link = document.createElement('a')
        let blob
        if (window.navigator.msSaveOrOpenBlob) {
          // for ie
          blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          window.navigator.msSaveOrOpenBlob(blob, '端末一覧.xlsx')
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else if (window.webkitURL && window.webkitURL.createObjectURL) {
          // for chrome (and safari)
          blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          link.setAttribute('download', '端末一覧.xlsx')
          link.setAttribute('href', window.webkitURL.createObjectURL(blob))
          link.click()
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else if (window.URL && window.URL.createObjectURL) {
          // for firefox
          blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          link.setAttribute('download', '端末一覧.xlsx')
          link.setAttribute('href', window.URL.createObjectURL(blob))
          link.click()
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else {
          let eventNumber = this.$store.state.error.errorCode.errorCode_140005
          let eventType = 9
          let reason = 'MSGCRC0007'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.finishWord =
            this.errorMsg.MSGCRC0007.name +
            this.errorMsg.MSGCRC0007.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFinishModal = true
          this.showloadingModal = false
          return
        }
        window.URL.revokeObjectURL(link)
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_140006
        let eventType = 3
        let reason = ''
        if (error.response) {
          reason = 'MSGCRC0022 '
          this.finishWord =
            this.errorMsg.MSGCRC0022.name +
            this.errorMsg.MSGCRC0022.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFinishModal = true
        this.showloadingModal = false
        return
      }
      this.showloadingModal = false
    }
  }
}
</script>

<style scoped>
.search {
  margin: auto 0;
  height: 55px;
}
</style>



// WEBPACK FOOTER //
// src/components/devices/controlbar.vue